/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3MetricsEgressBandwidthRequest = {
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Float Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3MetricsEgressBandwidthRequest$inboundSchema: z.ZodType<
  GetApiV3MetricsEgressBandwidthRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  end: z.nullable(z.number()).default(null),
  start: z.nullable(z.number()).default(null),
  step: z.number().default(7200),
});

/** @internal */
export type GetApiV3MetricsEgressBandwidthRequest$Outbound = {
  end: number | null;
  start: number | null;
  step: number;
};

/** @internal */
export const GetApiV3MetricsEgressBandwidthRequest$outboundSchema: z.ZodType<
  GetApiV3MetricsEgressBandwidthRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3MetricsEgressBandwidthRequest
> = z.object({
  end: z.nullable(z.number()).default(null),
  start: z.nullable(z.number()).default(null),
  step: z.number().default(7200),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsEgressBandwidthRequest$ {
  /** @deprecated use `GetApiV3MetricsEgressBandwidthRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsEgressBandwidthRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsEgressBandwidthRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsEgressBandwidthRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsEgressBandwidthRequest$Outbound` instead. */
  export type Outbound = GetApiV3MetricsEgressBandwidthRequest$Outbound;
}

export function getApiV3MetricsEgressBandwidthRequestToJSON(
  getApiV3MetricsEgressBandwidthRequest: GetApiV3MetricsEgressBandwidthRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsEgressBandwidthRequest$outboundSchema.parse(
      getApiV3MetricsEgressBandwidthRequest,
    ),
  );
}

export function getApiV3MetricsEgressBandwidthRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3MetricsEgressBandwidthRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsEgressBandwidthRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3MetricsEgressBandwidthRequest' from JSON`,
  );
}
